/* eslint-disable react-hooks/exhaustive-deps */
import {
  DeleteOutlined,
  MailOutline,
  PauseCircleOutline,
} from "@mui/icons-material";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import { Button, Tab, Tabs } from "@mui/material";
import { Card, CardContent, Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import { useNavigate } from "react-router-dom";
import API from "../../Utils/Interceptor/ApiMiddleware";
import DeleteConfirmationDialog from "../../components/Composables/DeleteDialogs";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import PersonIcon from "@mui/icons-material/Person";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";
const EmployerDescription = () => {
  const [backbutton, setbackbutton] = useState(false);
  const location = useLocation();
  const { id, email } = location.state || {};
  const [dashboardData, setdashboardData] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [emolyerMetricsData, setEmployerMatricsData] = useState([]);
  const [pause, setPause] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const navigate = useNavigate();

  const dataset = {
    "Basic Details": {
      Name: dashboardData?.Name || "NA",
      Email: dashboardData?.Email || "NA",
      "Phone No.": dashboardData?.Mobile || "NA",
      "Current Address": dashboardData?.["Current Address"] || "NA",
      "Date Joined": dashboardData?.["Date Joined"]
        ? dayjs(dashboardData["Date Joined"]).format("DD/MM/YYYY")
        : "NA",
    },
    "Employer Metrics": emolyerMetricsData || {},
  };

  // const fetchEmployerDescription = async () => {
  //   try {
  //     const response = await API.get(`/employer/get-employer-description`, {
  //       params: { email, user_id: id },
  //     });
  //     const dashboardData = response.data.data["Basic Details"];
  //     const employerMetricsData = response.data.data["Employer Metrics"];
  //     const activityData = response.data.data["Recent Activities"];
  //     const isPause = dashboardData?.is_pause === 1;

  //     setdashboardData(dashboardData);
  //     setActivityData(activityData);
  //     setEmployerMatricsData(employerMetricsData);
  //     setPause(isPause);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };
  const fetchEmployerDescription = async () => {
    setLoading(true);
    try {
      const response = await API.get(`/employer/get-employer-description`, {
        params: { email, user_id: id },
      });
      const dashboardData = response.data.data["Basic Details"];
      const employerMetricsData = response.data.data["Employer Metrics"];
      const activityData = response.data.data["Recent Activities"];
      const isPause = dashboardData?.is_pause === 1;

      setdashboardData(dashboardData);
      setActivityData(activityData);
      setEmployerMatricsData(employerMetricsData);
      setPause(isPause);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => setSnackbar({ ...snackbar, open: false });

  useEffect(() => {
    fetchEmployerDescription();
  }, []);

  const handleDialog = () => {
    setOpenDialog(true);
  };

  const handleDeleteConfirmation = async (confirmed) => {
    setOpenDialog(false);
    if (confirmed) {
      try {
        await deleteEmployerFunction();
      } catch (error) {
        console.error("Error deleting employer:", error);
      }
    }
  };

  const manageEmployer = async () => {
    const payload = {
      email: email,
      user_id: id,
    };

    try {
      if (pause) {
        await API.post("/employer/pause-employer", payload);
        setPause(false);
        setSnackbar({
          open: true,
          message: "Employer unpaused successfully",
          severity: "success",
        });
      } else {
        await API.post("/employer/pause-employer", payload);
        setPause(true);
        setSnackbar({
          open: true,
          message: "Employer paused successfully",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error managing employer status:", error);
    }
  };

  const deleteEmployerFunction = async () => {
    const payload = {
      email: email,
      user_id: id,
    };
    try {
      await API.post("/employer/delete-employer", payload);
      setSnackbar({
        open: true,
        message: "Employer deleted successfully",
        severity: "success",
      });
      setTimeout(() => navigate(-1), 2000);
    } catch (error) {
      console.error("Error deleting employer:", error);
      setSnackbar({
        open: true,
        message: "Error deleting employer",
        severity: "error",
      });
    }
  };

  const getIcon = (comment) => {
    if (comment?.includes("applied")) {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(33, 150, 243, 0.20)",
            borderRadius: "10px",
            height: "44px",
            minWidth: "44px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <PersonOutlineOutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    } else if (comment?.includes("created")) {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(255, 169, 60, 0.20)",
            borderRadius: "10px",
            height: "44px",
            minWidth: "44px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <PersonAddAlt1OutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    } else {
      return (
        <Box
          className="icon-container"
          sx={{
            border: " 1px solid rgba(76, 175, 80, 0.20)",
            borderRadius: "10px",
            height: "44px",
            minWidth: "44px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "background-color 0.5s",
          }}
        >
          <WorkHistoryOutlinedIcon
            className="icon"
            style={{ color: "#979797" }}
          />
        </Box>
      );
    }
  };

  const getColor = (comment) => {
    if (comment?.includes("applied")) {
      return "#2196F3";
    } else if (comment?.includes("created")) {
      return "#FFA93C";
    } else {
      return "#4CAF50 ";
    }
  };

  return (
    <div
      style={{
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
      }}
    >
      <div
        style={{
          backgroundColor: "#FFF",
          padding: "16px",
          borderRadius: "12px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {loading ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
                paddingBottom: "16px",
                gap: "12px",
                alignItems: "center",
              }}
            >
              <Button
                startIcon={
                  <ChevronLeftOutlinedIcon
                    style={{ height: "16px", width: "16px" }}
                  />
                }
                sx={{
                  "& .MuiButton-startIcon": backbutton
                    ? { marginRight: "4px !important" }
                    : {
                        margin: "0px",
                      },
                }}
                style={
                  backbutton
                    ? {
                        backgroundColor: "#3F95EA",
                        color: "white",
                        height: "24px",
                        fontSize: "12px",
                        textTransform: "none",
                      }
                    : {
                        backgroundColor: "#E7E7E7",
                        color: "#1A1A1A",
                        minWidth: "24px",
                        height: "24px",
                        padding: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }
                }
                onMouseEnter={() => setbackbutton(true)}
                onMouseLeave={() => setbackbutton(false)}
                onClick={() => navigate(-1)}
              >
                {backbutton ? "Back" : ""}
              </Button>
              <div
                style={{
                  color: "#151D48",
                  fontSize: "22px",
                  fontWeight: "600",
                }}
              >
                Employer Description
              </div>
            </div>

            <div style={{ display: "flex", gap: "16px", position: "relative" }}>
              <div
                style={{
                  width: "96px",
                  height: "96px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "8px",
                  backgroundColor: "#E3F2FD",
                }}
              >
                <PersonIcon style={{ fontSize: "96px", color: "#979797" }} />
              </div>

              <div>
                <div
                  style={{
                    color: "rgba(0, 0, 0, 0.87)",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {dataset["Basic Details"].Name}
                </div>
                <div
                  style={{
                    color: "rgba(0, 0, 0, 0.60)",
                    fontSize: "14px",
                    fontWeight: "400",
                  }}
                >
                  {dataset["Basic Details"]["Current Address"]}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    padding: "6px 0px",
                    color: "#006CB7",
                    alignItems: "center",
                  }}
                >
                  <span style={{ display: "flex", alignItems: "end" }}>
                    <MailOutline style={{ width: "20px", height: "20px" }} />
                  </span>
                  <span>
                    <a
                      href={`mailto:${dataset["Basic Details"].Email}`}
                      style={{
                        color: "#006CB7",
                        textDecoration: "none",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      {dataset["Basic Details"].Email}
                    </a>
                  </span>
                </div>
              </div>
              {dashboardData?.Status !== "Deleted" ? (
                <div style={{ position: "absolute", right: "0px" }}>
                  <Button
                    startIcon={
                      pause ? (
                        <PlayCircleOutlineOutlinedIcon />
                      ) : (
                        <PauseCircleOutline />
                      )
                    }
                    variant="outlined"
                    color={pause ? "success" : "warning"}
                    style={{ marginRight: "16px" }}
                    onClick={manageEmployer}
                  >
                    {pause ? "UnPause" : "Pause"}
                  </Button>

                  <Button
                    startIcon={<DeleteOutlined />}
                    variant="outlined"
                    color="error"
                    onClick={handleDialog}
                  >
                    Delete
                  </Button>
                </div>
              ) : null}
            </div>

            <Tabs
              value={"EmployerInfo"}
              style={{
                // margin: "20px 0px",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              }}
              sx={{
                "& .MuiTabs-indicator": {
                  height: "2px",
                },
              }}
            >
              <Tab
                value="EmployerInfo"
                label="Employer info"
                sx={{
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              />
            </Tabs>

            <div
              style={{
                display: "flex",
                gap: "16px",
                width: "100%",
                height: "calc(100% - 240px)",
              }}
            >
              {Object.entries(dataset).map(([sectionTitle, details]) => (
                <Card
                  key={sectionTitle}
                  elevation={0}
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid rgba(115, 119, 145, 0.08)",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "100%",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "4px 4px 0 0",
                      padding: "14px 20px",
                      backgroundColor: "rgba(63, 149, 234, 0.20)",
                      color: "#000",
                      fontSize: "14px",
                      fontWeight: "600",
                      flexShrink: 0,
                    }}
                  >
                    {sectionTitle}
                  </Box>
                  <CardContent
                    sx={{
                      padding: "16px 20px",
                      flexGrow: 1,
                      overflowY: "auto",
                    }}
                  >
                    {Object?.entries(details)?.map(([key, value]) => (
                      <Box
                        key={key}
                        sx={{
                          marginBottom: "8px",
                        }}
                        display={{ xs: "block", md: "block", lg: "flex" }}
                      >
                        <Typography
                          sx={{
                            // textTransform: "capitalize",
                            fontWeight: "400",
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.60)",
                            width: "140px",
                            whiteSpace: "normal", // Allows text to wrap to the next line
                            wordBreak: "break-word",
                            marginRight: "20px",
                          }}
                        >
                          {key}
                        </Typography>
                        <Typography
                          width={{
                            xs: "100%",
                            md: "100%",
                            lg: "calc(100% - 140px)",
                          }}
                          sx={{
                            fontWeight: "400",

                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            whiteSpace: "normal", // Allows text to wrap to the next line
                            wordBreak: "break-word",
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    ))}
                  </CardContent>
                </Card>
              ))}

              <Card
                elevation={0}
                sx={{
                  borderRadius: "4px",
                  border: "1px solid rgba(115, 119, 145, 0.08)",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  maxHeight: "100%",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    borderRadius: "4px 4px 0 0",
                    padding: "14px 20px",
                    backgroundColor: "rgba(63, 149, 234, 0.20)",
                    color: "#000",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    justifyContent: "space-between",
                    flexShrink: 0,
                  }}
                >
                  Recent Activities
                  {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "4px",
                  backgroundColor: "#FFF",
                  padding: "4px 8px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#04E000",
                    borderRadius: "100%",
                    width: "8px",
                    height: "8px",
                  }}
                />
                <div
                  style={{
                    color: "#737791",
                    fontSize: "12px",
                    fontWeight: "400",
                  }}
                >
                  Active 24 min Ago
                </div>
              </div> */}
                </Box>
                <CardContent
                  sx={{
                    padding: "16px 20px",
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                    overflowY: "auto",
                    alignItems:
                      activityData?.length === 0 ? "center" : "flex-start",
                    justifyContent:
                      activityData?.length === 0 ? "center" : "flex-start",
                    flexGrow: 1,
                  }}
                >
                  {activityData?.length === 0 ? (
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "#737791",
                      }}
                    >
                      No Recent Activities
                    </Typography>
                  ) : (
                    activityData?.map(
                      (item, index) =>
                        item?.notes !== null && (
                          <Box
                            key={index}
                            display={{ xs: "block", md: "block", lg: "flex" }}
                            alignItems={"center"}
                            gap={"14px"}
                            sx={{
                              "&:hover .icon-container": {
                                backgroundColor: getColor(item?.notes),
                              },
                              "&:hover .icon": {
                                color: "white !important",
                              },
                              "&:hover .activity-logs": {
                                fontWeight: "500 !important",
                              },
                            }}
                          >
                            {getIcon(item?.notes)}
                            <Box overflow="hidden">
                              <Typography
                                className="activity-logs"
                                sx={{
                                  fontWeight: 400,
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "wrap",
                                  fontSize: "14px",
                                  color: "#151D48",
                                  marginBottom: "2px",
                                }}
                              >
                                {item?.notes}
                              </Typography>
                              <Typography
                                sx={{ fontWeight: 400 }}
                                variant="body2"
                                color="#737791"
                                fontSize={"10px"}
                              >
                                {dayjs(item.date_modified).format("DD-MM-YYYY")}
                              </Typography>
                            </Box>
                          </Box>
                        )
                    )
                  )}
                </CardContent>
              </Card>
            </div>
          </>
        )}
      </div>
      <DeleteConfirmationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={handleDeleteConfirmation}
        pageName={"employer"}
      />
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
};

export default EmployerDescription;
